import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { normalizeExternalUrl } from '../utils/url';
import { optimizedImage } from '../utils/images';
import StarBorder from './reactbit/StarBorder';
import Turnstile from './Turnstile/Turnstile';
import { isTurnstileEnabled } from '../utils/turnstile';
import './ApplyProject.css';

// Bölümün tamamı admin panelinden yönetiliyor: açık/kapalı, başlık, buton
// metni ve adres. Kapalıysa veya adres boşsa hiçbir şey basılmıyor, böylece
// eksik ayar ölü bir buton üretmiyor.
const ApplyProject = ({ info }) => {
  // Doğrulama tamamlanana kadar buton pasif ve adres DOM'a hiç yazılmıyor.
  const [verified, setVerified] = useState(false);
  const captchaRequired = isTurnstileEnabled();
  const unlocked = !captchaRequired || verified;

  if (!info || !info.applyProjectEnabled) return null;

  const url = normalizeExternalUrl(info.applyProjectUrl);
  if (!url) return null;

  const title = info.applyProjectTitle || 'Apply for a Project';
  const buttonText = info.applyProjectButtonText || 'Apply Now';
  // Görsel opsiyonel: yoksa bölüm eskisi gibi tek sütun ve ortalanmış kalıyor.
  const imageUrl = optimizedImage(info.applyProjectImageUrl, 800);

  return (
    <motion.section
      className={`apply-project${imageUrl ? ' apply-project--with-image' : ''}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
      aria-labelledby="apply-project-title"
    >
      {imageUrl && (
        <div className="apply-project__media">
          <img
            src={imageUrl}
            alt=""
            className="apply-project__image"
            loading="lazy"
            decoding="async"
          />
        </div>
      )}

      <div className="apply-project__content">
        <h2 id="apply-project-title" className="apply-project__title">
          {title}
        </h2>

        {/* Ana sayfadaki "See All Projects" butonuyla aynı StarBorder animasyonu.
            Doğrulama beklenirken aynı görünüm <span> ile basılıyor: href yok,
            yani tıklama da bir yere gitmiyor. Buton pasifken kullanıcı ikinci
            kez tıklamak zorunda kalmıyor — widget kendi kendine çözülüyor ve
            adres o anda aktif hale geliyor. */}
        {unlocked ? (
          <a
            href={url}
            className="apply-project__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StarBorder as="span" className="apply-project__button" color="blue" speed="2s">
              {buttonText}
              <FiArrowRight className="apply-project__arrow" aria-hidden="true" />
            </StarBorder>
          </a>
        ) : (
          <span
            className="apply-project__link apply-project__link--locked"
            aria-disabled="true"
          >
            <StarBorder as="span" className="apply-project__button" color="blue" speed="2s">
              {buttonText}
              <FiArrowRight className="apply-project__arrow" aria-hidden="true" />
            </StarBorder>
          </span>
        )}

        {/* Widget doğrulamadan sonra da ekranda kalıyor: kullanıcı yeşil onay
            işaretini görüyor ve bölüm birden kısalmıyor. Ayrıca token'ın
            süresi dolduğunda haber verebiliyor — o an buton yeniden kilitlenir. */}
        {captchaRequired && (
          <Turnstile
            action="apply_project"
            onVerify={(token) => setVerified(Boolean(token))}
          />
        )}
      </div>
    </motion.section>
  );
};

export default ApplyProject;
